export default "__VITE_ASSET__87eb5e13__"